import React, { useRef, useEffect, useState } from 'react';
import './GameOverModal.css';
import CONSTANTS, { computeBasedness } from '../constants';


function GameOverModal({ twitterUser, isTestLevel, onClose, forceClosed, gameState, gameStats, name, levelDetails, levelID, gamePlayUUID, autoplay}) {
    const modalRef = useRef();

    const [basednessLevel, basedness_img_url] = computeBasedness(gameStats.totalScore, levelDetails.LEVEL_NAME);
    const [hasAttemptedSave, setHasAttemptedSave] = useState(false);
    const [saved, setHasSaved] = useState(false);
    const levelClass = `level-${levelID}`;
    const toDynamoDBFormat = (obj) => {
        const formattedObj = {};
    
        for (const [key, value] of Object.entries(obj)) {
            if (typeof value === "string") {
                formattedObj[key] = { S: value };
            } else if (typeof value === "number") {
                formattedObj[key] = { N: value.toString() };
            } else if (typeof value === "boolean") {
                formattedObj[key] = { BOOL: value };
            } else if (Array.isArray(value)) {
                formattedObj[key] = {
                    L: value.map(item => {
                        if (typeof item === 'object' && item !== null) {
                            // Ensuring that the object inside the array is wrapped with 'M'
                            return { M: toDynamoDBFormat(item) };
                        }
                        return toDynamoDBFormat({ tempKey: item }).tempKey;
                    })
                };
            } else if (typeof value === "object" && value !== null) {
                formattedObj[key] = { M: toDynamoDBFormat(value) }; 
            }
        }
    
        return formattedObj;
    };    
    const isWithinTimeRange = () => {
        const now = new Date();
        // Adjusting the date object for the Eastern timezone
        const easternTimeOffset = now.getTimezoneOffset() + (4 * 60); // 4 hours for Eastern Time. Adjust this if considering Daylight Saving Time.
        now.setMinutes(now.getMinutes() + easternTimeOffset);
    
        const startToday12pm = new Date(now);
        startToday12pm.setHours(12, 0, 0, 0);
    
        const endTomorrow1159pm = new Date(now);
        endTomorrow1159pm.setDate(endTomorrow1159pm.getDate() + 1);
        endTomorrow1159pm.setHours(23, 59, 59, 999);
    
        return now >= startToday12pm && now <= endTomorrow1159pm;
    }
    const saveDataToServer = async () => {
        let itemPayload = {
            gameplay: { S: gamePlayUUID },
            date: { S: new Date().toISOString() },
            score: { N: `${gameStats.totalScore}` },
            gameVersion: { S: levelDetails.LEVEL_VERSION || "Unknown" },
            levelID: {S: levelID},
            levelName: { S: levelDetails.LEVEL_NAME || "Unknown" },
            constantKey: { S: "ALL_GAMES" }, // to support partition
            metadata: {
                M: {
                    device: { S: "iOS" }
                }
            },
            gameStats: { M: toDynamoDBFormat(gameStats) }
        };
        if (name) {
            itemPayload.name = { S: name };
        }

        console.log("Deleting boardStateChanges and scoreChanges for long play");
        delete itemPayload.gameStats.M.boardStateChanges;
        delete itemPayload.gameStats.M.scoreChanges;

        if (autoplay) {
            itemPayload.score.N = 0;
        }
        
        if (twitterUser) {
            if (twitterUser.screen_name) {
                itemPayload.twitterUserName = { S: twitterUser.screen_name };
            }
            if (twitterUser.user_id) {
                itemPayload.twitterUserId = { S: twitterUser.user_id };
            }

            if (isWithinTimeRange()) {
                if (levelID === "nakamigo_crush") {
                    itemPayload.competition = { S: "mfers_vs_nakamigos_0923_nakamigo" };
                } else if (levelID === "basic") {
                    itemPayload.competition = { S: "mfers_vs_nakamigos_0923_mfers" };
                }
            }
        }
        
        const payload = {
            TableName: "gameplays",
            Item: itemPayload
        };

        try {
            console.log("saving game data to server");
            const response = await fetch(CONSTANTS.BACKEND_URL, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            console.log(data);
        } catch (error) {
            console.error('There was an error with the API call:', error);
        }
        setHasSaved(true);
    };

    useEffect(() => {
        if (gameState !== CONSTANTS.GAME_STATE_COMPLETE) {
            return;
        }
        if (twitterUser === null && name === null) {
            console.log("no saving info because anonymous and not logged in");
            return;
        }
        if (hasAttemptedSave) {
            console.log("we have already attempted a save, not trying again. this is a weird condition");
            return;
        }
        if (isTestLevel) {
            console.log("is a test level, we will not attempt to save");
            return;            
        }
        console.log("game end, triggering api call");
        setHasAttemptedSave(true);
        setTimeout(() => {
            saveDataToServer();
        }, 2000);
    }, [gameState]);
    

    if (forceClosed || (gameState !== CONSTANTS.GAME_STATE_COMPLETE && gameState !== CONSTANTS.GAME_STATE_ENDING)) {
        return null;
    }
    
    return (
        <div className={`gameOverModalOverlay ${levelClass}`}>
            <div className={`gameOverModalContent ${levelClass}`} ref={modalRef}>
            <div><b>congrats {twitterUser?.screen_name || name || "anon"}!</b></div>
            {saved === true ? (
                    <div style={{fontSize: '0.6em'}}>✅ saved to leaderboard!</div>
                ) : hasAttemptedSave === true ? (
                    <div style={{fontSize: '0.6em'}}>saving to leaderboard ....</div>
                ) : ""}
            <div className="equalWidthContainer">
            <div className="leftSection">
                    <img src={basedness_img_url} alt="Score Icon" className="scoreImage"/>
            </div>
            <div style={{fontSize: '0.7em'}} className="rightSection">
            <div>level: {levelDetails.LEVEL_NAME}</div>
            <div>total score: {gameStats.totalScore}</div>
            

                <div>basedness Level: {basednessLevel}</div>
                {
                    levelID === 'tiny_dino' ? (
                        <div># of rawrizard Used: {gameStats.powerUps}</div>
                    ) : levelID === 'nakamigo_crush' ? (
                        <div># of king Spartans Used: {gameStats.powerUps}</div>
                    ) : levelID === 'book_of_bee' ? (
                        <div># of power up's used: {gameStats.powerUps}</div>
                    ) : (
                        <div># of power up's used: {gameStats.powerUps}</div>
                    )
                }
        </div>
    </div>    
                {/* Conditionally render the credits section */}
                {levelDetails.CREDITS && levelDetails.CREDITS.length > 0 && (
                    <div className="creditsSection"> {/* Wrap the credits section */}
                        <table>
                            <thead>
                                <tr>
                                    <th>Credits</th>
                                </tr>
                            </thead>
                            <tbody>
                                {levelDetails.CREDITS.map((credit, index) => (
                                    <tr key={index}>
                                        <th style={{fontSize: '0.7em'}}>
                                            {credit.key}:
                                        </th>
                                        <td style={{fontSize: '0.7em'}}>{credit.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <button className={`close-button ${levelClass}`} onClick={onClose}>Close</button>
            </div>
        </div>
    );
    
    
    
}

export default GameOverModal;